import { FieldErrors } from 'old-rhf';

const getNestedFieldError = (splitedName: string[], errors: FieldErrors): FieldErrors | null => {
  const error = errors[splitedName[0]];
  if (typeof error?.message === 'string') {
    return error;
  }
  if (!error) {
    return null;
  }
  splitedName.shift();
  return getNestedFieldError(splitedName, error);
};

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const getFieldError = (fieldName: string, formErrors: FieldErrors): FieldErrors | null => {
  const isNestedField = fieldName.includes('.');
  return isNestedField ? getNestedFieldError(fieldName.split('.'), formErrors) : formErrors[fieldName];
};

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const hasFieldError = (fieldName: string, formErrors: FieldErrors): boolean => {
  return Boolean(getFieldError(fieldName, formErrors));
};
